import styles from '../../styles/components/blogs/TableOfContents.module.css';
import { scrollToHeading } from '../../utils/helpers/blogUtils';

const TableOfContents = ({ tableOfContents, activeHeading }) => {
    if (!tableOfContents || tableOfContents.length === 0) return null;

    return (
        <aside className={styles.tableOfContents}>
            <p className={styles.tocTitle}>Table of Contents</p>
            <ul className={styles.tocList}>
                {tableOfContents.map((item, index) => (
                    <li key={index} className={styles.tocItem}>
                        <button
                            onClick={() => scrollToHeading(item.id)}
                            className={`${styles.tocLink} ${activeHeading === item.id ? styles.active : ''}`}
                            data-toc-link
                            data-heading-id={item.id}
                        >
                            {item.text}
                        </button>
                    </li>
                ))}
            </ul>
        </aside>
    );
};

export default TableOfContents;
